(() => {
  "use strict";
  function removeDuplicates(host) {
    const nativeIds = new Set([...host.querySelectorAll("[data-mcp-native-badges] [data-milanus-badge]")].map((badge) => badge.dataset.milanusBadge));
    if (!nativeIds.size) return;
    host.querySelectorAll(":scope > .mcp-badge-stack .mcp-badge").forEach((badge) => {
      if (nativeIds.has(badge.dataset.mcpBadge)) badge.remove();
    });
    host.querySelectorAll(":scope > .mcp-badge-stack").forEach((stack) => {
      if (!stack.querySelector(".mcp-badge")) stack.remove();
    });
  }
  function reconcile(root) {
    if (!(root instanceof Element)) return;
    const hosts = new Set();
    if (root.matches(".mcp-badge-host")) hosts.add(root);
    root.querySelectorAll?.(".mcp-badge-host").forEach((host) => hosts.add(host));
    root.closest?.(".mcp-badge-host") && hosts.add(root.closest(".mcp-badge-host"));
    hosts.forEach(removeDuplicates);
  }
  document.querySelectorAll(".mcp-badge-host").forEach(removeDuplicates);
  new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach(reconcile)))
    .observe(document.documentElement, { childList: true, subtree: true });
})();
